// global-error-handler.ts
import { ErrorHandler, Injectable, NgZone, Provider } from '@angular/core';
import { Logger } from '@shared/services/logger';

/**
 * Global error handler for the application. It captures unhandled errors and logs them.
 * This is useful for tracking errors that occur outside of Angular's zone.
 * And it will prevent the app from crashing due to unhandled errors.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private logger: Logger,
    private zone: NgZone,
  ) {}

  /* eslint-disable-next-line */
  handleError(error: any): void {
    this.zone.run(() => {
      // Get meaningful stack trace or error info
      const message = error?.error?.message || error?.message || 'Unknown error';
      const name = error.name || '';

      this.logger.error(`${name}: ${message}`, error);
    });
  }
}

export function provideGlobalErrorHandler(): Provider {
  return {
    provide: ErrorHandler,
    useClass: GlobalErrorHandler,
  };
}
